/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTAXSCALE = {
    Paye: '1',
    FixedTaxRate: '2'
} as const;
export type IAPTAXSCALE = typeof IAPTAXSCALE[keyof typeof IAPTAXSCALE];


export function IAPTAXSCALEFromJSON(json: any): IAPTAXSCALE {
    return IAPTAXSCALEFromJSONTyped(json, false);
}

export function IAPTAXSCALEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTAXSCALE {
    return json as IAPTAXSCALE;
}

export function IAPTAXSCALEToJSON(value?: IAPTAXSCALE | null): any {
    return value as any;
}

